var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTruckSecure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.241 7.31747C6.09708 7.36982 6 7.51682 6 7.68239V8.73293C6 10.3999 6.93765 11.8958 8.36114 12.5C8.45046 12.5379 8.54954 12.5379 8.63886 12.5C10.0624 11.8958 11 10.3999 11 8.73293V7.68239C11 7.51682 10.9029 7.36983 10.759 7.31747L8.67568 6.55956C8.56165 6.51807 8.43835 6.51807 8.32432 6.55956L6.241 7.31747Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 4C2.89543 4 2 4.89543 2 6V16C2 16.9321 2.63766 17.7153 3.50056 17.9371C3.53409 16.0331 5.088 14.5 7 14.5C8.933 14.5 10.5 16.067 10.5 18H13.5C13.5 16.067 15.067 14.5 17 14.5C18.912 14.5 20.4659 16.0331 20.4994 17.9371C21.3623 17.7153 22 16.9321 22 16V12.75H15V11.25H21.4L18.6005 7.75061C18.2209 7.27618 17.6463 7 17.0387 7H15V6C15 4.89543 14.1046 4 13 4H4ZM7.7751 13.8807C5.74372 13.0185 4.5 10.9411 4.5 8.73281V7.68227C4.5 6.95393 4.93019 6.19803 5.72818 5.90773L7.8115 5.14982C8.2568 4.98782 8.74321 4.98782 9.1885 5.14982L11.2718 5.90773C12.0698 6.19803 12.5 6.95394 12.5 7.68227V8.73281C12.5 10.9411 11.2563 13.0185 9.2249 13.8807C8.76105 14.0775 8.23893 14.0775 7.7751 13.8807Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 18C9 19.1046 8.10457 20 7 20C5.89543 20 5 19.1046 5 18C5 16.8954 5.89543 16 7 16C8.10457 16 9 16.8954 9 18Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19 18C19 19.1046 18.1046 20 17 20C15.8954 20 15 19.1046 15 18C15 16.8954 15.8954 16 17 16C18.1046 16 19 16.8954 19 18Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruckSecure);
export default __webpack_public_path__ + "static/media/truck-secure.83164e524f0c4f716a6252d93fa26807.svg";
export { ForwardRef as ReactComponent };